<div class="container-fluid" style="position: relative; height: 100vh; padding-left: 3rem;">

  <div class="d-flex justify-content-center mt-5 mb-5">
    <div class="change-password-layout container-fluid form-content shadow-5 col-md-6">
      <div class="row justify-content-center form">
        <h2 class="login-form-title">Upload Confluence Document</h2>

        <form class="text-center row g-3" [formGroup]="form" novalidate>
          <div class="col-md-12 text-start">
            <label for="projectSelect" class="form-label">Project</label>
            <select id="projectSelect" class="form-select" formControlName="project"
              [ngClass]="{ 'is-invalid': submitted && form.get('project')?.invalid }">
              <option value="" disabled>Select a project</option>
              <option *ngFor="let project of projects" [value]="project">{{ project }}</option>
            </select>
            <div *ngIf="submitted && form.get('project')?.invalid" class="invalid-feedback d-block">
              Please select a project
            </div>
          </div>

          <div class="col-md-12 text-start">
            <label for="versionSelect" class="form-label">Version</label>
            <select id="versionSelect" class="form-select" formControlName="version"
              [disabled]="!selectedProject || availableVersions.length === 0"
              [ngClass]="{ 'is-invalid': submitted && form.get('version')?.invalid }">
              <option value="" disabled>Select a version</option>
              <option *ngFor="let version of availableVersions" [value]="version">{{ version }}</option>
            </select>
            <div *ngIf="submitted && form.get('version')?.invalid" class="invalid-feedback d-block">
              Please select a version
            </div>
          </div>

          <div class="col-md-12 text-start">
            <label for="fileInput" class="form-label">ZIP File</label>
            <div class="file-upload-area" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)">
              <input #fileInput type="file" id="fileInput" class="file-input" accept=".zip"
                (change)="onFileSelected($event)" [ngClass]="{ 'is-invalid': submitted && !selectedFile }" />
              <div class="file-upload-content">
                <i class="fa-solid fa-file-zipper" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
                <p *ngIf="!fileName" class="mb-0">
                  <strong>Click to upload</strong> or drag and drop
                </p>
                <p *ngIf="!fileName" class="text-muted small mb-0">ZIP files only</p>
                <p *ngIf="fileName" class="mb-0">
                  <strong>{{ fileName }}</strong>
                </p>
                <p *ngIf="fileName" class="text-muted small mb-0">
                  {{ (selectedFile?.size || 0) / 1024 / 1024 | number:'1.2-2' }} MB
                </p>
              </div>
            </div>
            <div *ngIf="submitted && !selectedFile" class="invalid-feedback d-block">
              Please select a ZIP file
            </div>
          </div>
        </form>

        <!-- Upload Progress -->
        <div *ngIf="uploading" class="mt-4">
          <div class="progress" style="height: 25px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
              [style.width.%]="uploadProgress" [attr.aria-valuenow]="uploadProgress" aria-valuemin="0"
              aria-valuemax="100">
              {{ uploadProgress }}%
            </div>
          </div>
          <p class="text-center mt-2 text-muted">Uploading to S3...</p>
        </div>

        <!-- Upload Success Message -->
        <div *ngIf="uploadSuccess" class="mt-4">
          <div class="alert alert-success">
            <i class="fa-solid fa-check-circle"></i> File uploaded successfully!
            <div *ngIf="fileKey" class="mt-2">
              <small><strong>S3 Key:</strong> {{ fileKey }}</small>
            </div>
          </div>
          <div class="mt-3 text-center">
            <a [href]="pipelineTriggerUrl" target="_blank" rel="noopener noreferrer"
              class="btn btn-outline-primary btn-sm">
              Open GitLab Pipelines
            </a>
          </div>
        </div>

        <!-- Pipeline Status -->
        <div *ngIf="pipelineStatus" class="mt-4">
          <div class="card">
            <div class="card-header">
              <strong>Pipeline Status</strong>
            </div>
            <div class="card-body">
              <div *ngIf="pipelineStatus === 'triggering'" class="text-center">
                <div class="spinner-border spinner-border-sm text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 mb-0">Triggering pipeline...</p>
              </div>
              <div *ngIf="pipelineStatus === 'pending' || pipelineStatus === 'running'" class="text-center">
                <div class="spinner-border spinner-border-sm text-info" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 mb-0">Pipeline {{ pipelineStatus }}...</p>
                <p *ngIf="pipelineId" class="text-muted small mb-0">Pipeline ID: {{ pipelineId }}</p>
              </div>
              <div *ngIf="pipelineStatus === 'success'" class="text-center">
                <i class="fa-solid fa-check-circle text-success" style="font-size: 2rem;"></i>
                <p class="mt-2 mb-0 text-success"><strong>Pipeline completed successfully!</strong></p>
                <p *ngIf="pipelineId" class="text-muted small mb-0">Pipeline ID: {{ pipelineId }}</p>
              </div>
              <div *ngIf="pipelineStatus === 'failed'" class="text-center">
                <i class="fa-solid fa-times-circle text-danger" style="font-size: 2rem;"></i>
                <p class="mt-2 mb-0 text-danger"><strong>Pipeline failed</strong></p>
                <p *ngIf="pipelineId" class="text-muted small mb-0">Pipeline ID: {{ pipelineId }}</p>
              </div>
              <div *ngIf="pipelineUrl" class="mt-3 text-center">
                <a [href]="pipelineUrl" target="_blank" class="btn btn-sm btn-outline-primary">
                  View Pipeline in GitLab
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex flex-row-reverse align-items-center mt-4">
          <div class="p-2">
            <button type="button" class="btn btn-primary" (click)="onClickUpload()"
              [disabled]="loading || uploading || !selectedFile || !form.get('project')?.value || !form.get('version')?.value">
              <div *ngIf="loading || uploading" class="spinner-border spinner-border-sm text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span *ngIf="!loading && !uploading">Upload & Trigger Pipeline</span>
              <span *ngIf="loading || uploading">Processing...</span>
            </button>
          </div>
          <div class="p-2" *ngIf="uploadSuccess || pipelineStatus">
            <button type="button" class="btn btn-secondary" (click)="resetForm()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>